var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"indexCol"},[_vm._v(_vm._s(_vm.idx+1))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.song.url}},[_vm._v(_vm._s(_vm.song.title))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.song.user.username))]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.song.user.displayAvatarURL,"height":"25","width":"25","alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5143f460","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SongRow.vue
// module id = null
// module chunks = 